import DocumentMapDataGeometry from "Areas/SharedFeatures/types/documentMapDataGeometry";
import { MAP_GEOMETRY_TYPE } from "Common/dictionaries/mapGeometryType";
import { uuid7 } from "Common/uuid7";
import head from "lodash/head";
import map from "lodash/map";
import reverse from "lodash/reverse";
import { MultiLineString, Polygon } from "ol/geom";
import Point from "ol/geom/Point";
import { toLonLat } from "ol/proj";
export default (documentId, onAddGeometry) => (e) => {
    var _a, _b, _c;
    const geometry = (_a = e.feature) === null || _a === void 0 ? void 0 : _a.getGeometry();
    if (!geometry || !documentId || !onAddGeometry)
        return;
    if (geometry instanceof Point) {
        const coords = geometry.getCoordinates();
        const newData = coords
            ? new DocumentMapDataGeometry(uuid7(), MAP_GEOMETRY_TYPE.POINT, [reverse(toLonLat(coords))], Date.now())
            : undefined;
        newData && onAddGeometry(documentId, newData);
    }
    else if (geometry instanceof Polygon) {
        const coords = head(geometry.getCoordinates());
        const newData = coords
            ? new DocumentMapDataGeometry(uuid7(), MAP_GEOMETRY_TYPE.AREA, map(coords, coord => reverse(toLonLat(coord))), Date.now())
            : undefined;
        newData && onAddGeometry(documentId, newData);
    }
    else if (geometry instanceof MultiLineString) {
        const coords = head(geometry.getCoordinates());
        const newData = coords
            ? new DocumentMapDataGeometry(uuid7(), MAP_GEOMETRY_TYPE.LINE, map(coords, coord => reverse(toLonLat(coord))), Date.now())
            : undefined;
        newData && onAddGeometry(documentId, newData);
    }
    ((_b = e.target) === null || _b === void 0 ? void 0 : _b.removeFeature) && ((_c = e.target) === null || _c === void 0 ? void 0 : _c.removeFeature(e.feature));
};
